import * as React from 'react'
import Header from 'app/React/Components/Header/Header'
import WhenStep from 'app/React/Components/misc/WhenStep'
import Step5 from 'app/React/Components/Main/Steps/Step5'
import Footer from 'app/React/Components/Footer/Footer'
import ConfiguratorContainer from "app/React/ConfiguratorContainer";

export function Checkout(props) {
  return (
    <ConfiguratorContainer {...props}>
        <div id='mg-configurator'>
          <Header></Header>
          <main>
            <WhenStep step={5}>
              <Step5 />
            </WhenStep>
          </main>
          <Footer />
        </div>
    </ConfiguratorContainer>
  )
}
